import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

interface IStylesProps {
  buttonsOnly?: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
  // Pagination styling
  paginationContainer: ({ buttonsOnly }: IStylesProps) => ({
    '&&': {
      position: 'static',
      bottom: 0,
      right: 0,
      width: buttonsOnly ? 'auto' : '100%',
      zIndex: 100,

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',

      [theme.breakpoints.down('laptop')]: {
        padding: buttonsOnly ? 0 : `${SPACES.xxl} ${SPACES.xxl} ${SPACES.xl}`,
      },
      [theme.breakpoints.up('laptop')]: {
        padding: `${SPACES.xxxl} 60px ${SPACES.xxl}`,
      },
    },
  }),
  paginationWrapper: ({ buttonsOnly }: IStylesProps) => ({
    '&&': {
      marginLeft: buttonsOnly ? 0 : 'auto',
      display: 'flex',
      alignItems: 'center',

      [theme.breakpoints.down('tablet')]: {
        gap: SPACES.xxxs,
      },
      [theme.breakpoints.up('tablet')]: {
        gap: SPACES.s,
      },
    },
  }),
  paginationTextWrapper: {
    '&&': {
      display: 'flex',
      alignItems: 'baseline',
    },
  },
  paginationText: {
    '&&': {
      fontSize: FONTS.SIZES.m,
      lineHeight: 1.337,
      color: theme.palette.custom.darkBlue2,
    },
  },
  paginationSelectWrapper: {
    '&&': {
      color: theme.palette.custom.darkBlue2,
    },
    '& .MuiNativeSelect-select': {
      appearance: 'auto',
    },
    '& .MuiNativeSelect-icon': {
      display: 'none',
    },
  },
  paginationSelectOption: {
    textAlign: 'center',
  },
  paginationButtonWrapper: {
    '&&': {
      display: 'flex',

      [theme.breakpoints.down('tablet')]: {
        gap: SPACES.xxxs,
      },
      [theme.breakpoints.up('tablet')]: {
        gap: SPACES.xs,
      },
    },
  },
  paginationButton: {
    '&&': {
      borderRadius: '17.5px',
      width: 50,
      height: 35,

      '&:disabled': {
        backgroundColor: theme.palette.custom.grey,
        color: theme.palette.custom.primary,
      },
    },
  },
}))

export { useStyles }
